module.exports = __webpack_public_path__ + "static/vargouille-b53013db1b2dbb9726501b48c81b0f0b.jpeg";